import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import products from '../products';
import editVendorDialog from '../dialog.editVendorDialog';
import editProductDialog from '../products/dialog.editProductDialog';
import controller from './vendor.controller';
import directive from './vendor.directive';


export default angular.module('app.components.advisory.vendorManagement.vendor', [
  alerts,
  confirmDialog,
  constants,
  editVendorDialog,
  editProductDialog,
  loaderService,
  products,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
])
  .directive('vmVendor', directive)
  .controller('VendorController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.vendor created');
